import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/commonFields';
import { locationFields } from './common/locationFields';
import { vendorFields } from './common/vendorFields';
import { productFields, purchasedMaterialFields } from './common/productFields';
import { beaCodeField, expenditureFields } from './common/expenditureFields';
import { msg } from '@lingui/core/macro';
import { ghgCategoryField } from './common/commonFields';

export const expenditureMappedMetadata = {
  displayName: msg({
    message: 'Expenses',
    context: 'Activity data schema name for expenditure',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...vendorFields,
    ...productFields,
    ...purchasedMaterialFields,
    ...expenditureFields,
    bea_code: beaCodeField,
    expenditure_category: {
      displayName: msg({
        message: 'Expenditure category',
        context: 'The display name for expenditure category field',
      }),
    },
    ghg_category: ghgCategoryField,
  },
} as const satisfies BatMetadataConfigEntry;
